import { connect, type ConnectedProps } from 'react-redux';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { type WithTranslation, withTranslation } from 'react-i18next';
import { compose } from '@reduxjs/toolkit';
import { APP_TITLE } from '@/config';
import ProfileAvatar from '@/components/ProfileAvatar';
import CustomLink from '@/components/CustomLink';
import DashboardMenu from '@/components/DashboardMenu';
import { Logo } from '@/static';
import { user, logout } from '@/slices/user';
import { type RootState } from '@/store';
import styles from './styles';

type Props = ConnectedProps<typeof connector> & WithTranslation;

const AuthHeader = ({ user, logout }: Props) => {
  const handleLogout = () => {
    logout();
  };

  return (
    <Box component="header" sx={styles.root}>
      <Box sx={styles.left}>
        <Box component={CustomLink} to="/" sx={styles.logoLink}>
          <Logo />
        </Box>

        <Typography sx={styles.title}>{APP_TITLE}</Typography>
      </Box>

      {user && (
        <Box sx={styles.right}>
          <Box sx={styles.userInfo}>
            {(user?.alias || user?.full_name) && (
              <Typography>{user.alias || user.full_name}</Typography>
            )}

            {user?.email && <Typography>{user.email}</Typography>}
          </Box>

          <ProfileAvatar user={user} />
          <DashboardMenu onLogout={handleLogout} />
        </Box>
      )}
    </Box>
  );
};

const connector = connect(
  (state: RootState) => ({
    user: user(state),
  }),
  {
    logout,
  },
);

export default compose(connector, withTranslation())(AuthHeader);
